import { useNavigate } from "react-router-dom";
import { Col, Row } from "antd";
import { useEffect, useMemo, useState } from "react";
import {
  FileUpload,
  SimulationTypeOptions,
  UploadedVideos,
} from "./components";
import { ModelTypeIcon } from "./icons";

import {
  cameraTypeDropdownOptions,
  initialStateOfModelTypeKeys,
  modelTypeListForAthletics,
  modelTypeListForBaseBall,
  modelTypeListForGolf,
  stylesForTab,
  sportNameObj,
  sportTabsData,
  swingSettingsData,
  cameraSettingsData,
  SPORT_KEYS,
} from "./constants";
import { useCurrentUserContext } from "providers";
import {
  getInitialData,
  getSelectedModelTypes,
  handleToggleOptions,
} from "./helpers";
import { useGetInitialData } from "./hooks/useGetInitialData";
import TabsRow from "./components/tabsRow";
import { Accordians } from "./components/accordians";
import styles from "./styles.module.scss";

export default function M2cTonal() {
  const { ATHLETICS, BASEBALL, GOLF } = SPORT_KEYS;

  const {
    getUploadedVideos,
    uploadedVideoList,
    uploadedVideosLoading,
    handleRequestProcess,
  } = useGetInitialData();

  const capturedFrameRateDefault = 240;
  const { user } = useCurrentUserContext();

  const [sportName, setSportName] = useState(BASEBALL);
  const [ModelTypeSettingsOptions, setModelTypeSettingsOptions] = useState({
    ...modelTypeListForBaseBall,
  });
  const [modelTypeSettings, setModelTypeSettings] = useState({
    ...initialStateOfModelTypeKeys,
  });

  const { initialAllData } = useMemo(
    () =>
      getInitialData({
        email: user?.email,
        capturedFrameRateDefault,
      }),
    [user?.email]
  );

  const [resolutionOtherOption, setResolutionOtherOption] = useState(10);

  const [swingSettings, setSwingSettings] = useState({ ...swingSettingsData });

  const [cameraSettings, setCameraSettings] = useState({
    ...cameraSettingsData,
  });

  const [genericState, setGenericState] = useState({ ...initialAllData });
  const navigate = useNavigate();

  useEffect(() => {
    getUploadedVideosData();
  }, []);

  function handleClickProcessingBtn() {
    if (sportName === GOLF || sportName === ATHLETICS)
      return navigate("/results");
    handleRequestProcess();
  }

  async function getUploadedVideosData() {
    await getUploadedVideos();
  }

  const handleChangeSportTypeTab = (event) => {
    const sportNameClicked = event.currentTarget.getAttribute("data-name");
    let modelTypeList = modelTypeListForBaseBall;
    switch (sportNameClicked) {
      case GOLF:
        modelTypeList = modelTypeListForGolf;
        break;
      case BASEBALL:
        modelTypeList = modelTypeListForBaseBall;
        break;
      case ATHLETICS:
        modelTypeList = modelTypeListForAthletics;
        break;
      default:
        modelTypeList = modelTypeListForBaseBall;
        break;
    }
    setModelTypeSettingsOptions(modelTypeList);
    setGenericState((prevGenericState) => {
      return {
        ...prevGenericState,
        [sportNameClicked]: {
          ...prevGenericState[sportNameClicked],
          modelType: getSelectedModelTypes(modelTypeList),
        },
      };
    });
    setSportName(sportNameClicked);
  };

  function getSwingTileClicked({ mainTitle, item }) {
    setSwingSettings({ ...swingSettings, [mainTitle]: item.value });

    setGenericState((prevGenericState) => {
      return {
        ...prevGenericState,
        [sportName]: {
          ...prevGenericState[sportName],
          [mainTitle]: item.value,
        },
      };
    });
  }
  function getCameraTileClicked({ mainTitle, item }) {
    if (item.value === "1920X1080") setResolutionOtherOption(10);
    setCameraSettings({ ...cameraSettings, [mainTitle]: item.value });

    setGenericState((prevGenericState) => {
      return {
        ...prevGenericState,
        [sportName]: {
          ...prevGenericState[sportName],
          [mainTitle]: item.value,
        },
      };
    });
  }

  function getModelTypeClicked({ item }) {
    // changing option boolean value to true or false so that we can filter only true value to send to server
    let toggledOptionsAfterClicked = {
      ...ModelTypeSettingsOptions,
      options: ModelTypeSettingsOptions.options.map((option) => {
        if (option.value === item.value) {
          return {
            ...option,
            [item.value.toLowerCase()]: !option[item.value.toLowerCase()],
          };
        }
        return option;
      }),
    };

    if (sportName === GOLF || sportName === BASEBALL) {
      toggledOptionsAfterClicked = handleToggleOptions(
        toggledOptionsAfterClicked,
        item
      );
    }

    const currentModalTypeSettings = toggledOptionsAfterClicked.options.reduce(
      (emptyObj, item) => {
        return { ...emptyObj, [item.value]: item[item.value] };
      },
      {}
    );

    setModelTypeSettingsOptions(toggledOptionsAfterClicked);
    setModelTypeSettings(currentModalTypeSettings);
    setGenericState((prevGenericState) => {
      return {
        ...prevGenericState,
        [sportName]: {
          ...prevGenericState[sportName],
          modelType: getSelectedModelTypes(toggledOptionsAfterClicked),
        },
      };
    });
  }

  function getVersion({ item, version }) {
    // changing option version value for specific model type
    const updatedListAfterVersionSelect = {
      ...ModelTypeSettingsOptions,
      options: ModelTypeSettingsOptions.options.map((option) => {
        if (option.value === item.value) {
          return {
            ...option,
            version,
          };
        }
        return option;
      }),
    };
    setModelTypeSettingsOptions(updatedListAfterVersionSelect);
    setGenericState({
      ...genericState,
      modelType: getSelectedModelTypes(updatedListAfterVersionSelect),
    });
  }

  function getFinalData({ sportName, genericState }) {
    return genericState[sportName];
  }

  const allSettingsSelected = getFinalData({ sportName, genericState });

  function handleChangeSlider(event) {
    const { name, value } = event.target;

    setGenericState((prevGenericState) => {
      return {
        ...prevGenericState,
        [sportName]: {
          ...prevGenericState[sportName],
          [name]: value,
        },
      };
    });
  }

  function handleChangeCameraType(valueOfCameraType) {
    setGenericState({ ...genericState, cameraType: valueOfCameraType });
  }

  const genricStateSportKey = sportNameObj[sportName] || {};
  const activeSportState = genericState[genricStateSportKey] || {};

  return (
    <div className={styles.simulationContainer}>
      <div className={styles.heading}>Tonal Simulation</div>

      <Row>
        <Col span={24}>
          <FileUpload
            allSettingsSelected={allSettingsSelected}
            getUploadedVideosData={getUploadedVideosData}
          />
        </Col>
      </Row>
    </div>
  );
}
